import apiRequest from "../../apiCall";

export function PostBlogCommentApi(formData) {
//   console.log("fomdatadatadata", formData);
  return new Promise((resolve, reject) => {
    apiRequest("post", "blogComment", formData, true, false)
      .then((res) => {
        sessionStorage.setItem("blogComment", JSON.stringify(res));
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function GetBlogCommentApi(url){
    return new Promise((resolve, reject)=>{
        apiRequest("get", url, null, false, false)
        .then((res)=>{
            resolve(res)
        })
        .catch((error)=>{
            reject(error)
        })
    })
}


export function GetPublishedBlogCommentApi(url){
  return new Promise((resolve, reject)=>{
      apiRequest("get", url, null, false, false)
      .then((res)=>{
          resolve(res)
      })
      .catch((error)=>{
          reject(error)
      })
  })
}
export function PutBlogCommentApi(urlId, formData){
  return new Promise((resolve, reject)=>{
    apiRequest("post", urlId, formData, true, true)
    .then((res)=>{
      sessionStorage.setItem("blogComment", JSON.stringify(res));
      resolve(res);
    })
    .catch((error) => {
      reject(error);
    });
  });
}

export function DeleteBlogCommentApi(_id, formData) {
  console.log("formData",formData)
  return new Promise((resolve, reject) => {
    apiRequest("post", `blogComment/${_id}`, formData, true, true)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}